import { render, staticRenderFns } from "./scrollUp.vue?vue&type=template&id=74d88f92&"
import script from "./scrollUp.vue?vue&type=script&lang=js&"
export * from "./scrollUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports